/***
 * Add v-maxHeight directive to an element that should fill the height of the parent element
 * By default the bounging height will be the parent DOM element
 * Optionally, you can set property containerRefName to a ref of an alternate element
 * Or you can pass the arg to the directive: v-maxHeight:parentRefName
 */
export default {
	data() {
		return {
			targetElement: undefined,
			bindingRef: null
		};
	},
	props: {
		containerRefName: {
			type: String
		},
		offset: {
			type: Number,
			default: 18
		},
		noMaxHeight: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		this.setWidth();
		this.setMaxHeight();
		window.addEventListener('resize', this.setWidth);
		window.addEventListener('resize', this.setMaxHeight);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.setWidth);
		window.removeEventListener('resize', this.setMaxHeight);
	},
	directives: {
		maxHeight: {
			bind: function(el, binding, vnode) {
				const component = vnode.context;

				component.targetElement = el;
				component.bindingRef = binding.arg;

				if (binding.value !== undefined) {
					component.offset = binding.value;
				}
			}
		}
	},
	methods: {
		setWidth() {
			this.windowWidth = window.innerWidth;
		},
		setMaxHeight() {
			let container;
			let top;
			let height;
			let ref = this.bindingRef || this.containerRefName;
			const parent = this.$parent;

			if (ref) {
				//if the containerRef was set as a property on this component
				//check in same component first
				container = this.$refs[ref];

				if (!container) {
					//then check the parent
					container = parent.$refs[ref];
				}
			} else if (this.targetElement) {
				//get the parent element by default
				container = this.targetElement.parentElement;
			}

			if (container) {
				top = container.getBoundingClientRect().top;

				if (this.maxHeightOverride && !this.isTabletMode) {
					height = this.maxHeightOverride;
				} else {
					height = window.innerHeight - this.offset - top;
				}

				//don't set a max height for the tablet table because it's height needs to be enough to show all the vertical column names without scrolling
				if (!this.isTabletMode && !this.noMaxHeight) {
					this.targetElement.style['max-height'] = `${height}px`;
				}
			}
		}
	}
};
